import { Image } from '@chakra-ui/react';
import React from 'react';
import footerLogo from '@/assets/magnumbet/images/logo/logo.png';

export default function index() {
  return <Image src={footerLogo} minW="200px" maxW="210px" minH="40px" />;
}
